import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const addVariant = api(async function addVariant({ scenarioId, name, rateCardId, ruleSetIds }) {
    return mutate(
        gql`
            mutation AddVariant($scenarioId: String!, $name: String!, $rateCardId: String!, $ruleSetIds: [String]) {
                addVariant(scenarioId: $scenarioId, name: $name, rateCardId: $rateCardId, ruleSetIds: $ruleSetIds) {
                    id
                    name
                    variantCount
                    variants {
                        id
                        name
                        rateCardId
                        rateCardName
                        ruleSetIds
                        ruleSetNames
                        status
                        annualCost
                        isStale
                    }
                }
            }
        `,
        { scenarioId, name, rateCardId, ruleSetIds },
        { returns: "addVariant" }
    )
})
